import { Router } from "./components/Router";
import "./App.css";
import { theme } from "./theme";
import { IconMoon, IconSun } from "@tabler/icons-react";
import { useLocalStorage } from "@mantine/hooks";
import ThemeToggle from "./components/ThemeToggle/ThemeToggle";

function App() {
  console.log("init app");
  return (
    <>
      <Router />
    </>
  );
}

export default App;
